import { render, staticRenderFns } from "./PscDeficiencyCodeGroupChart.vue?vue&type=template&id=163ef070&scoped=true&"
import script from "./PscDeficiencyCodeGroupChart.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencyCodeGroupChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ef070",
  null
  
)

export default component.exports